var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgSpintaxSvg = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9335 11.1355C18.4163 10.8756 18.6577 10.7456 18.7187 10.5892C18.7717 10.4535 18.7568 10.3007 18.6785 10.1778C18.5883 10.0362 18.3263 9.95552 17.8023 9.79411L7.54895 6.63569C7.1209 6.50384 6.90687 6.43791 6.76231 6.49096C6.6364 6.53716 6.53717 6.63639 6.49097 6.7623C6.43792 6.90686 6.50385 7.12088 6.6357 7.54894L9.79409 17.8023C9.9555 18.3263 10.0362 18.5883 10.1778 18.6785C10.3006 18.7568 10.4535 18.7717 10.5892 18.7187C10.7456 18.6577 10.8756 18.4163 11.1355 17.9335L13.4109 13.7078C13.4496 13.6361 13.4689 13.6002 13.4937 13.5688C13.5157 13.5409 13.5409 13.5157 13.5688 13.4937C13.6002 13.4689 13.6361 13.4495 13.7078 13.4109L17.9335 11.1355Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14235 2.11979V0.75M3.54497 3.54497L2.57639 2.57638M3.54497 10.7951L2.57639 11.7637M10.7951 3.54497L11.7637 2.57638M2.11979 7.14234H0.75M13.4109 13.7078L11.1355 17.9336C10.8756 18.4163 10.7456 18.6577 10.5892 18.7187C10.4535 18.7717 10.3006 18.7568 10.1778 18.6785C10.0362 18.5883 9.9555 18.3263 9.79409 17.8023L6.6357 7.54894C6.50385 7.12088 6.43792 6.90686 6.49097 6.7623C6.53717 6.63639 6.6364 6.53716 6.76231 6.49096C6.90687 6.43791 7.1209 6.50384 7.54895 6.63569L17.8023 9.79411C18.3263 9.95552 18.5883 10.0362 18.6785 10.1778C18.7568 10.3007 18.7717 10.4535 18.7187 10.5892C18.6577 10.7456 18.4163 10.8756 17.9335 11.1355L13.7078 13.4109C13.6361 13.4495 13.6002 13.4689 13.5688 13.4937C13.5409 13.5157 13.5157 13.5409 13.4937 13.5688C13.4689 13.6002 13.4496 13.6361 13.4109 13.7078Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSpintaxSvg, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/spintaxSvg.52b69ef8.svg";
export { ForwardRef as ReactComponent };